import React from "react";
import '../index.css';

function Project(){
    return(
        <>
        <div className="heroic">
            <h1>RECENT <span>PROJECTS</span></h1>
        </div>
        </>
    );
}

export default Project;